import home from "./home"; // 首页
// import userInfo from "./userInfo"; // 用户信息

import news from "./news"; // 新闻
import trade from "./trade";
import productDetail from "./productDetail"; // 商品详情
import orderDetail from "./orderDetail"; // 订单详情
import userCenter from "./userCenter"; // 用户中心
import offer from "./offer"; // 出价
import login from "./login"; // login
import look from "./look"; // 看货相关

const router = [
  ...home,
  ...productDetail,
  ...orderDetail,
  ...userCenter,
  ...news,
  ...offer,
  // ...login,
  ...look,
  ...trade
];
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js